export type PolicyDocumentType = {
  label: string;
  value: number;
  source?: string;
};

export const PolicyDocumentTypes: PolicyDocumentType[] = [
  {
    label: 'Name Change',
    value: 1,
  },
  {
    label: 'Ownership Change',
    value: 2,
  },
  {
    label: 'Beneficiary Change Request',
    value: 3,
  },
  {
    label: 'Life Policy Change & Service Request',
    value: 4,
  },
  {
    label: 'Premium and Billing Change Request',
    value: 5,
  },
  {
    label: 'Policy Change & Service Request',
    value: 6,
  },
  {
    label: 'HIPAA Authorization - New York',
    value: 7,
  },
  {
    label: 'HIPAA Authorization',
    value: 8,
  },
  {
    label: 'Claim Document',
    value: 9,
    source: 'ORDINARY'
  },
  {
    label: 'Claim Documents - Critical Illness',
    value: 10,
    source: 'GROUP'
  },
  {
    label: 'Claim Documents - Accident',
    value: 11,
    source: 'GROUP'
  },
  {
    label: 'Claim Documents - Disability',
    value: 12,
    source: 'GROUP'
  },
  {
    label: 'Claim Documents - Hospital Indemnity',
    value: 13,
    source: 'GROUP'
  },
  {
    label: 'Claim Documents - Wellness',
    value: 14,
    source: 'BOTH'
  },
    {
    label: 'Claim Documents - OPT',
    value: 15,
    source: 'BOTH'
  },  
];
